// Admin Matrix webhook/Voxuy audit surface.
// Backend wire: /api/v2/admin/matrix-webhooks and /api/v2/admin/voxuy-outbox.
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import { AdminLayout } from "../_layout/AdminLayout";

const AdminMatrixWebhooksPage = lazyWithRetry(
  () => import("./pages/AdminMatrixWebhooksPage"),
);
const VoxuyKanbanPage = lazyWithRetry(() => import("./pages/VoxuyKanbanPage"));

const routes: RouteObject[] = [
  {
    Component: AdminLayout,
    children: [
      { path: "/admin/matrix-webhooks", Component: AdminMatrixWebhooksPage },
      { path: "/admin/voxuy/kanban", Component: VoxuyKanbanPage },
    ],
  },
];

export default routes;
